export default __webpack_public_path__ + "static/media/regional-map-page.6790fff3.png";